<p-dialog
  class="intro-dialog"
  [(visible)]="showOverlay"
  (onShow)="handleOverlayOpened()"
  (onHide)="handleOverlayClosed()"
>
  <video id="intro" width="100%" controls>
    <source src="/assets/mov/intro.mp4" type="video/mp4" />
  </video>
</p-dialog>
